import Dialog from './dialog.jsx';
import { useState } from 'react';

const InfoPopup = ({ title, message, onClose }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
        if (onClose) {
            onClose();
        }
    };

    return (
        <>
            <span className="info-icon" onClick={() => setIsOpen(true)}>?</span>
            <Dialog isOpen={isOpen} onClose={handleClose}>
                <div className="info-popup">
                    <h2>{title}</h2>
                    <p>{message}</p>
                    <button onClick={handleClose}>Close</button>
                </div>
            </Dialog>
        </>
    );
};

export default InfoPopup;